import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {viasReducer} from 'vias';

import auth from './auth';

export default combineReducers({
  routing: routerReducer,
  auth,
  vias: viasReducer,
});



// WEBPACK FOOTER //
// ./app/states/reducers/index.js